module.exports = __webpack_public_path__ + "static/media/mockremitta.ef23c50f.jpg";